module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-five4.87a4b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-five4.png
// module id = VWCu
// module chunks = 0